import React, { useState, useEffect } from 'react';
import { graphql, withPrefix, useStaticQuery } from 'gatsby';
import Footer  from '@vfuk/core-footer';
import uniqueId from '../../helpers/uniqueId';
import { PageFooterWrapper } from './styles/PageFooter.styles';
import {
  PurePageFooterProps,
  AllContentfulPageFooterData,
  LegalLinksProps,
  PageFooterProps
} from './types/PageFooter.types';

export const PurePageFooter: React.FC<PurePageFooterProps> = ({
  footerLinks,
  copyrightText,
}) => {
  const [pageTitle, setPageTitle] = useState<string>('');

  useEffect(() => {
    setTimeout(() => {
      // TODO: This two lines below is needed because the title of the html on the "/" path is not set. When this is fixed, then they can be removed
      let metaName = document
        .querySelector('meta[property="og:title"]')
        ?.getAttribute('content');
      metaName = metaName ? metaName : 'Not Set';
      setPageTitle(document.title.length == 0 ? metaName : document.title);
    }, 500);
  }, []);

  const legalLinks: Array<LegalLinksProps> = [];

  footerLinks.forEach((column) => {
    column.links.forEach(link => (
      legalLinks.push({
        id: link.id,
        text: link.name,
        href: withPrefix(`${link.url}`),
        dataAttributes: {
          "title": link.name,
          "data-analytics-element": uniqueId(link.name),
          "data-analytics-context": pageTitle,
          "data-analytics-category": "Link",
          "data-testid": "footer-legal",
        }
      })
    ));
  });

  return (
    <PageFooterWrapper>
      <Footer
        legalLinks={legalLinks}
        copyrightText={copyrightText.copyrightText}
      />
    </PageFooterWrapper>
  );
};

const PageFooter = ({ firstLanguageLocalCode, secondLanguageUrlPrefix, isSecondLanguageOnUrl }: PageFooterProps) => {
  const {
    allContentfulPageFooter: { nodes },
  } = useStaticQuery<AllContentfulPageFooterData>(graphql`
    {
      allContentfulPageFooter {
        nodes {
          node_locale
          footerLinks {
            links {
              id
              name
              url
            }
          }
          copyrightText {
            copyrightText
          }
        }
      }
    }
  `);

  const firstLanguageFootData = nodes.find(node => node.node_locale.slice(0, 2) === firstLanguageLocalCode);
  const secondLanguageFootData = nodes.find(node => node.node_locale.slice(0, 2) === secondLanguageUrlPrefix);

  let usedLanguageFootData;
  if (isSecondLanguageOnUrl && secondLanguageFootData) {
    usedLanguageFootData = secondLanguageFootData;
  } else {
    usedLanguageFootData = firstLanguageFootData!;
  }

  const { footerLinks, copyrightText } = usedLanguageFootData;
  return (
    <PurePageFooter footerLinks={footerLinks} copyrightText={copyrightText} />
  );
};

export default PageFooter;
